<template src="./activityExamAnalysis.html"></template>

<script>
import apiV3 from '../../NetworkManager/apiV3';
import ExamRepository from "../../Repository/Exam";

export default {
  name: "activityExamAnalysis",
  props: ["prop_exam", "prop_allAttempts"],
  data() {
    return {
      examAnalysis: {},
      item: {},
      isLoading: false,
      count: 0,
      attemptNo: 1,
      attemptData: {},
      questions: 0,
      time: 0,
      responseLength: 0,
      timeTake: '',
      actualAnswer: [],
      backgroundColor: "#E7E7FFCF",
      orange: "#FF4F1F",
      showFullImage: false,
      imageUrl: '',
      showQuestionFullImage: false,
      downArrow: "mdi-chevron-down"
    };
  },
  async created() {
    this.count = 0
    this.responseLength = this.prop_exam.response?.length
    // console.log('this.responseLength', this.responseLength)
    // console.log(' ', this.prop_exam, this.prop_allAttempts)
    this.isMobileView = this.$store.getters["liveData/get_isMobileView"];
    this.examRepositoryInstance = new ExamRepository(this);
    this.subjectsMapping = this.$store.getters["mappings/get_subjectsMapping"];
    this.$store.commit("liveData/set_selectedActivityName", "Exam Analysis");
    this.examRepositoryInstance = new ExamRepository(this);
    this.userData = this.$store.getters["user/get_userData"];
    this.item = this.prop_exam;
    console.log('this.item', this.item);
    await this.getAnalysis();
    this.calculateAttempt(1)
  },
  computed: {
    attemptOptions() {
      return Array.from({ length: this.responseLength }, (_, i) => i + 1);
    }
  },
  methods: {
    openImage(imageUrl) {
      this.imageUrl = imageUrl
      this.showFullImage = true;
    },
    getRadioClass(option, question) {
      const correctAnswer = this.getCorrectedAns(question.question); // Get the correct answer
      if (option === correctAnswer) {
        return "radio-correct"; // Class for correct option
      }
      if (option === question.selectedAnswer && option !== correctAnswer) {
        return "radio-wrong"; // Class for wrong option
      }
      return ""; // Default class for other options
    },
    calculateObtainedMarks(que, ans) {
      let marks = 0
      if (Array.isArray(this.actualAnswer) && this.actualAnswer.length > 0) {
        this.actualAnswer.map((item) => {
          if (item.question === que) {
            // console.log('item', item);
            if (ans === item.answer) {

              marks = item.marks
            }
          }
        })
      }
      return marks
    },
    async getAnalysis() {
      this.count = 0
      try {
        this.isLoading = true
        this.actualAnswer = []
        const values = await apiV3.getRequest(
          `/exam/getQuestionsByExam?examId=${this.item._id}`
        );
        this.actualAnswer = [...values.questions]
        // console.log('this.actualAnswer', this.actualAnswer);
        const { answers, totalMarksObtained, totalOutOf } = await apiV3.getRequest(
          `/exam/answers?examId=${this.item._id}&studentId=${this.userData.uId}`
        );
        this.examAnalysis = {
          questions: answers,
          totalMarksObtained,
          totalOutOf
        }
        // console.log('answers', answers);
        // this.examAnalysis.questions.forEach((exam) => {
        //   if (exam.answer === exam.selectedAnswer) this.count++
        // })
        this.examName = this.item.name;
        this.subjectName = this.item.subjectName;
        this.examType = this.item.examType;
      } catch (e) {
        console.log('errrr');
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
    getCorrectedAns(que) {
      let ans = ''
      if (Array.isArray(this.actualAnswer) && this.actualAnswer.length > 0) {
        this.actualAnswer.map((item) => {
          if (item.question === que) {
            ans = item.answer
          }
        })
      }
      return ans
    },
    checkAnsIsCorrect(selectedAns, que) {
      // console.log('selectedAns', selectedAns);
      // console.log('que', que);
      let flag = false
      if (Array.isArray(this.actualAnswer) && this.actualAnswer.length > 0) {
        this.actualAnswer.map((item) => {
          if (item.question === que && selectedAns === item.answer) {
            // console.log('item', item);
            flag = true
          }
        })
      }
      return flag
    },
    async calculateAttempt(i) {
      console.log('Selected attempt number:', i);
      this.count = 0;
      this.attemptData = {};

      if (this.prop_exam.response[i - 1]) {
        this.attemptData = this.prop_exam.response[i - 1];
        const questionIds = this.prop_exam.questions.A.map((item) => item)
        console.log('questionIds', questionIds);
        try {
          const { questions } = await apiV3.getRequest('/exam/questions', {
            examId: this.prop_exam._id,
            role: 0
          })
          this.attemptData.answers.forEach(answer => {
            questions.forEach(question => {
              if (answer.questionId === question._id) {
                answer.attachment = question.attachment
              }
            })
          })
          console.log('Attempt Data:', this.attemptData);
          console.log('questionsquestions', questions);
        } catch (e) {
          console.error(e)
        }
        if (this.actualAnswer.length > 0 && Array.isArray(this.attemptData.answers)) {
          this.actualAnswer.forEach((item, index) => {
            this.attemptData.answers.forEach((ans) => {
              if (ans.question === item.question) {
                ans.index = index;
                ans.answer = item.answer;
                ans.marks = item.marks;
              }
            });
          });
          this.attemptData.answers = this.attemptData.answers.sort((a, b) => a.index - b.index);
          console.log('Sorted Answers:', this.attemptData.answers);
        }

        this.attemptData.totalOutOf = 0;
        this.attemptData.totalMarksObtained = 0;

        for (let j = 0; j < this.attemptData?.answers.length; j++) {
          this.attemptData.totalOutOf = Number(this.attemptData.totalOutOf) + Number(this.attemptData?.answers[j].marks);
          if (this.attemptData?.answers[j].answer === this.attemptData?.answers[j].selectedAnswer) {
            this.count++;
            this.attemptData.totalMarksObtained = Number(this.attemptData.totalMarksObtained) + Number(this.attemptData?.answers[j].marks);
          }
        }

        this.questions = this.attemptData.answers.length;
        this.time = this.attemptData.timeTaken;

      } else {
        console.log('No data available for this attempt.');
        alert('Attempt Not Given');
        this.questions = 0;
        this.attemptData.totalMarksObtained = 0;
        this.attemptData.totalOutOf = 0;
        this.count = 0;
        this.time = '00:00';
      }
    },
    goBack() {
      if (this.isMobileView) {
        this.$store.commit("liveData/set_tabSelectionForTest", 1);
        this.$router.push("/activityExams2");
      } else {
        console.log('hereee');
        this.$store.commit("liveData/set_tabSelectionForTest", 1);
        this.$router.push("/activityExams");
      }
      // if (this.isMobileView) {
      //     this.$router.push({
      //         name: "activityCourseMaterialRevamped2",
      //         params: {
      //             prop_course: this.prop_subjectInfo,
      //             prop_indexOfSelectedSection: this.indexOfSelectedSection,
      //             prop_indexSelectedSubSection: this.indexSelectedSubSection,
      //             prop_courseDetails: this.prop_courseDetails,
      //             prop_subject: this.prop_subject
      //         }
      //     });
      // } else {
      //     this.$router.push({
      //         name: "activityCourseMaterialRevamped",
      //         params: {
      //             prop_course: this.prop_subjectInfo,
      //             prop_indexOfSelectedSection: this.indexOfSelectedSection,
      //             prop_indexSelectedSubSection: this.indexSelectedSubSection,
      //             prop_courseDetails: this.prop_courseDetails,
      //             prop_subject: this.prop_subject
      //         }
      //     });
      // }
    }
  }
};
</script>
<style scoped src="./activityExamAnalysis.css"></style>
